var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Dark / Edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Dark-/-Edit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carbon-edit",
    transform: "translate(1.000000, 1.000000)",
    fill: "#32325D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Icon-Path",
    points: "0.5 18.5 21.5 18.5 21.5 20 0.5 20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.05,5.75 C18.65,5.15 18.65,4.25 18.05,3.65 L15.35,0.95 C14.75,0.35 13.85,0.35 13.25,0.95 L2,12.2 L2,17 L6.8,17 L18.05,5.75 Z M14.3,2 L17,4.7 L14.75,6.95 L12.05,4.25 L14.3,2 Z M3.5,15.5 L3.5,12.8 L11,5.3 L13.7,8 L6.2,15.5 L3.5,15.5 Z",
    id: "Icon-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.8f60cf58ef82655b09233559334fe391.svg";
export { ForwardRef as ReactComponent };